import React from 'react'
import { Link } from '@inertiajs/react'

import { ceil, multiply } from 'lodash'
import { format } from 'date-fns'

import Pagination from '@/Shared/Pagination'
import Icon from '@/Shared/Icon'

import { getLabel } from '@/utils'

export default function({ consumeds: { data, links }, item }) {
    function getQuantitySuffix(quantity) {
        if (item === 'normal_waste_21_bag') {
            return `(${ceil(multiply(quantity, 30))} Bags)`;
        }

        if (item === 'normal_waste_30_bag') {
            return `(${ceil(multiply(quantity, 16))} Bags)`;
        }

        if (item === 'normal_waste_39_bag') {
            return `(${ceil(multiply(quantity, 8))} Bags)`;
        }

        return '';
    }

    return (
        <div>
            <div className="mt-6 overflow-x-auto rounded bg-white shadow">
                <table className="w-full whitespace-nowrap">
                    <thead>
                    <tr className="text-left font-bold">
                        <th className="px-6 pb-4 pt-5">Sr No.</th>
                        <th className="px-6 pb-4 pt-5">Item</th>
                        <th className="px-6 pb-4 pt-5">Quantity</th>
                        <th className="px-6 pb-4 pt-5">Date</th>
                    </tr>
                    </thead>

                    <tbody>
                    {data?.map(({ id, quantity, date }, index) => {
                        return (
                            <tr
                                key={id}
                                className="focus-within:bg-gray-100 hover:bg-gray-100"
                            >
                                <td className="border-t">
                                    <Link
                                        tabIndex="-1"
                                        href={route('consumed.edit', id)}
                                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                                    >
                                        {index + 1}
                                    </Link>
                                </td>
                                <td className="border-t">
                                    <Link
                                        tabIndex="-1"
                                        href={route('consumed.edit', id)}
                                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                                    >
                                        {getLabel(item)}
                                    </Link>
                                </td>
                                <td className="border-t">
                                    <Link
                                        tabIndex="-1"
                                        href={route('consumed.edit', id)}
                                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                                    >
                                        {quantity} {getQuantitySuffix(quantity)}
                                    </Link>
                                </td>
                                <td className="border-t">
                                    <Link
                                        href={route('consumed.edit', id)}
                                        className="flex items-center px-6 py-4 focus:text-indigo-700 focus:outline-none"
                                    >
                                        {format(date, 'PPP')}
                                    </Link>
                                </td>
                                <td className="w-px border-t">
                                    <Link
                                        tabIndex="-1"
                                        href={route('consumed.edit', id)}
                                        className="flex items-center px-4 focus:outline-none"
                                    >
                                        <Icon
                                            name="cheveron-right"
                                            className="block h-6 w-6 fill-current text-gray-400"
                                        />
                                    </Link>
                                </td>
                            </tr>
                        )
                    })}
                    {data.length === 0 && (
                        <tr>
                            <td className="border-t px-6 py-4" colSpan="4">
                                No record found.
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>

            <Pagination links={links} />
        </div>
    )
}
